import React, { useState, useEffect, useRef } from "react";
import Player from "@vimeo/player";
import firstFamilyImg from "../../assets/images/video-carousel/png/first-family.png";
import thumbnail1 from "../../assets/images/video-carousel/png/thumb1.webp";
import thumbnail2 from "../../assets/images/video-carousel/png/thumb2.webp";
import thumbnail3 from "../../assets/images/video-carousel/png/thumb3.webp";
import arrowLeftSvg from "../../assets/images/blogs/svg/leftArrow.svg";
import arrowRightSvg from "../../assets/images/blogs/svg/rightArrow.svg";

const VideoCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoaded, setIsLoaded] = useState(false);
  const playerRefs = useRef([]);
  const containerRefs = useRef([]);

  const videos = [
    {
      id: "1040682463",
      title: "Unlimited Coverage for 4 Major Illnesses",
      description:
        "Unlimited Dreams, Unlimited Coverage! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization. ",
      poster: thumbnail3,
    },
    {
      id: "1040680999",
      title: "Essential Coverage for 4 Major Illnesses ",
      description:
        "Dream Big,  Coverage Essential! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization.",
      poster: thumbnail1,
    },
    {
      id: "1040665299",
      title: "Absolutely Zero Waiting Period",
      description:
        "Zero Waiting Period, Coverage From Day1! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization.",
      poster: thumbnail2,
    },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isLoaded) return;

    videos.forEach((video, index) => {
      if (containerRefs.current[index]) {
        const options = {
          id: video.id,
          background: false,
          muted: true,
          autoplay: false,
          loop: true,
          controls: true,
          responsive: true,
        };
        playerRefs.current[index] = new Player(
          containerRefs.current[index],
          options
        );
      }
    });

    return () => {
      playerRefs.current.forEach((player) => {
        if (player && typeof player.destroy === "function") {
          player.destroy();
        }
      });
    };
  }, [isLoaded]);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const getImageStyle = (index) => {
    const totalImages = videos.length;
    const offset =
      ((index - activeIndex + totalImages) % totalImages) -
      Math.floor(totalImages / 2);
    const maxOffset = Math.floor(totalImages / 2);

    // Responsive calculations
    let baseWidth;
    if (windowWidth >= 1440) {
      baseWidth = 790;
    } else if (windowWidth > 1024 && windowWidth < 1440) {
      baseWidth = 500;
    } else {
      baseWidth = Math.min(windowWidth * 0.4, 590);
    }

    const scale = 1 - Math.abs(offset) * 0.15;

    // Calculate a responsive offset factor
    const responsiveOffsetFactor = Math.max(
      0.1,
      Math.min(0.17, windowWidth / 5000)
    );
    const translateX = offset * (baseWidth * responsiveOffsetFactor);

    return {
      position: "absolute",
      width: "100%",
      maxWidth: `${baseWidth}px`,
      transform: `translateX(${translateX}px) scale(${scale})`,
      // opacity: 1 - Math.abs(offset) * 0.3,
      filter: `brightness(${1 - Math.abs(offset) * 0.5})`,
      zIndex: totalImages - Math.abs(offset),
      transition: "all 0.3s ease-in-out",
      borderRadius: "1.5rem", // Explicitly set border-radius
    };
  };

  const scroll = (direction) => {
    setActiveIndex(
      (prevIndex) =>
        (prevIndex + (direction === "right" ? 1 : -1) + videos.length) %
        videos.length
    );
  };

  return (
    <div className="px-6 lg:px-[120px] pb-20 lg:pb-[120px] w-full h-full hidden lg:flex flex-col justify-center items-center">
      <h1 className="text-[40px] leading-[54px] font-semibold mb-6 lg:mb-3 text-[#27506E]">
        Video
      </h1>
      <div className="flex flex-row gap-4 items-center justify-between w-full">
        <button
          onClick={() => scroll("left")}
          className="hidden lg:block left-[56px] rounded-full text-white"
        >
          <img
            src={arrowLeftSvg}
            alt="arrow-left"
            className="h-10 w-10 lg:h-12 lg:w-12"
          />
        </button>
        <div className="relative w-full">
          <div className="flex flex-row items-center justify-center gap-4 relative w-full">
            <img className="invisible h-[460px]" src={firstFamilyImg} />
            {videos.map((video, index) => (
              <div
                key={index}
                ref={(el) => (containerRefs.current[index] = el)}
                className="absolute rounded-3xl overflow-hidden"
                style={{
                  ...getImageStyle(index),
                  backgroundImage: `url(${video.poster})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            ))}
          </div>
        </div>
        <button
          onClick={() => scroll("right")}
          className="hidden lg:block right-[56px] rounded-full text-white"
        >
          <img
            src={arrowRightSvg}
            alt="arrow-right"
            className="h-10 w-10 lg:h-12 lg:w-12"
          />
        </button>
      </div>
      <div className="flex flex-col gap-2 text-center items-center">
        <p className="font-medium text-xl leading-[26px] text-black">
          {videos[activeIndex].title}
        </p>
        <p className="text-black opacity-60 max-w-[75%] leading-[22px] text-base font-normal">
          {videos[activeIndex].description}
        </p>
      </div>
    </div>
  );
};

export default VideoCarousel;
